import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types'

import * as LogsActions from '../../actions/actionLogs'
import LogsDom from '../../components/Screens/ActionLogs'
import ActionLogModal from '../../components/Screens/ActionLogs/Modal'
import { RedDot, GreenDot } from '../../components/Screens/Estate/Store/StatusDot/StatusDot.styles'

class ActionLogs extends Component {
    static propTypes = {
        logs: PropTypes.arrayOf(PropTypes.shape({})),
        search: PropTypes.string,
        fetchLogs: PropTypes.func.isRequired,
        changeSelectedLog: PropTypes.func.isRequired,
        changeLogSearch: PropTypes.func.isRequired,
        selectedEstate: PropTypes.string.isRequired,
        selectedLog: PropTypes.shape({}),
        pagination: PropTypes.shape({
            currentPage: PropTypes.number.isRequired,
            to: PropTypes.number.isRequired,
            total: PropTypes.number.isRequired,
        }).isRequired,
    }

    static defaultProps = {
        logs: [],
        search: '',
        selectedLog: null,
    }

    state = {
        sort: [{ fieldToSort: 'created_at', sortType: 'DESC' }],
    }

    componentDidMount() {
        this.fetchLogs()
    }

    async componentDidUpdate(lastProps) {
        const { selectedEstate: lastEstate } = lastProps
        const { selectedEstate: nextEstate, changeSelectedLog, changeLogSearch } = this.props
        if (lastEstate !== nextEstate) {
            await changeSelectedLog(null)
            await changeLogSearch('')
            this.fetchLogs()
        }
    }

    // On Change any input value
    onChangeSort = (sort) => {
        const { sort: prevSort } = this.state
        const areEqual =
            sort.length === prevSort.length &&
            sort.every((value, index) => value.fieldToSort === prevSort[index].fieldToSort && value.sortType === prevSort[index].sortType)
        this.setState({ sort }, () => {
            if (!areEqual) this.fetchLogs()
        })
    }

    // On Change any input value
    onChangeInput = async ({ target: { value } }) => {
        const { changeLogSearch } = this.props
        await changeLogSearch(value)
        this.fetchLogs()
    }

    onChangeSelectedLog = async (selectedLog) => {
        const { changeSelectedLog, logs } = this.props
        const log = logs.find((l) => l.id === selectedLog)
        await changeSelectedLog(log)
    }

    /**
     * Fetch logs information
     */
    async fetchLogs() {
        const { fetchLogs, search } = this.props
        const { sort } = this.state

        await fetchLogs({
            search,
            order: sort.length ? sort[0].fieldToSort : null,
            orderType: sort.length ? sort[0].sortType : null,
        })
    }

    calculateStatusColor = (status) => {
        if (status >= 200 && status < 300) return <GreenDot />
        return <RedDot />
    }

    calculateMethodColor = (method) => {
        switch (method) {
            case 'POST':
                return 'blue'
            case 'PUT':
                return 'green'
            case 'DELETE':
                return 'red'
            default:
                return 'yellow'
        }
    }

    buildNextPageFunc() {
        const { pagination, search, fetchLogs } = this.props
        const { sort } = this.state
        const { currentPage, to, total } = pagination

        if (to < total) {
            return () =>
                fetchLogs({
                    search,
                    order: sort.length ? sort[0].fieldToSort : null,
                    orderType: sort.length ? sort[0].sortType : null,
                    page: currentPage + 1,
                })
        }

        return null
    }

    render() {
        const { logs, search, selectedLog } = this.props
        const { sort } = this.state
        return (
            <LogsDom
                valueSearch={search}
                logs={logs}
                onChangeSearch={this.onChangeInput}
                onChangeSelected={this.onChangeSelectedLog}
                calculateStatusColor={this.calculateStatusColor}
                calculateMethodColor={this.calculateMethodColor}
                sortable={sort}
                onChangeSort={this.onChangeSort}
                nextPage={this.buildNextPageFunc()}
            >
                {selectedLog && <ActionLogModal selectedLog={selectedLog} isOpen={!!selectedLog} onClickCancel={() => this.onChangeSelectedLog(null)} />}
            </LogsDom>
        )
    }
}

const mapStateToProps = ({ app: { selectedEstate }, actionLogs: { logs, search, selectedLog, pagination } }) => ({
    selectedEstate,
    logs,
    search,
    selectedLog,
    pagination,
})

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            ...LogsActions,
        },
        dispatch
    )

export default connect(mapStateToProps, mapDispatchToProps)(ActionLogs)
